import React from 'react';
import { Redirect } from "react-router-dom";

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
import SelectField from '../Molecules/SelectField';
import SingleNextButton from '../Atoms/SingleNextButton';
import Form from '../StepComponents/Form';
import StepShell from '../StepComponents/StepShell';
import { setApp, getApp} from '../../index';
import { emailRegex, nameRegex } from '../../Utils/ValidationPatterns';
import { phoneTypes } from '../../Utils/SelectOptions';

class StepBasicIdentity extends React.Component {

    constructor(props) {
        super(props)
        var authCheck = getApp('auth1');
        this.state = {
            checked: authCheck,
        }
        this.getUserIp();
    }
    
    // Event Handler for "Vantage West has my permission to contact me..."
    authClicked() {
        this.setState({
            checked: !this.state.checked,
            notFound: false
        });
        setApp('auth1', !this.state.checked);
    }

    async getUserIp() {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setApp('userip', data.ip);
    }

    render() {
        // Display Navigation bar
        document.querySelector('body').classList.add('hidden-header');
        
        // Get Product from state
        // If there's no #tag, try to lookup state and see if there's any product which was specified
        var existingProduct = getApp('product');
        var backUrl = '/loan-application/';
        var currentMember = getApp('currentMember');
        var activeInAz = getApp('currentActiveAz');

        if(currentMember === "false" && activeInAz === "true")
            backUrl = '/loan-application/eligibility';

        return (
            <StepShell stepID="StepBasicIdentity"
                friendlyText="Thanks for verifying your Membership eligibility. Let's continue on this application."
                requestText="First, we need some basic information about you."
                progress="28%"
                progressLabel="Intro"
                backLink={backUrl}
            >
                <Form nextLink="/loan-application/verification">
                    <input name="product" type="hidden" val={`${existingProduct}`} />
                    <TextField name="fname" label="First Name" required={true} pattern={nameRegex} />
                    <TextField name="mname" label="Middle Name" pattern={nameRegex} />
                    <TextField name="lname" label="Last Name" required={true} pattern={nameRegex} />
                    <TextField name="email" label="Email Address" required={true} type="email" pattern={emailRegex} title="example@example.com" />
                    <div className="loanApp-form-row">
                        <div className="col col-8">
                            <NumberField name="phone" label="Primary Telephone (555) 555-5555" required={true} type="tel" minLength="14" format="(###) ###-####" pattern="^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$" />
                        </div>
                        <div className="col col-4">
                            <SelectField options={phoneTypes} required={true} name="phoneType" placeholder="Phone Type" labelType="hidden"
                            />
                        </div>
                    </div>
                    <div className="loanApp-checkbox hug">
                        <input type="checkbox" name="auth1" value="yes" className="pull-left loanApp-form-control" onChange={this.authClicked.bind(this)} defaultChecked={this.state.checked} />
                        <label htmlFor="auth1">Vantage West has my permission to contact me regarding my application.</label>
                    </div>
                    <div className="hug">
                        <span className="auth1-required-message error-message">You must check the box to give us permission to contact you to continue your application.</span>
                    </div>
                    <SingleNextButton nextBtnTxt="next" />
                </Form>

            </StepShell>
        )
    }
}

export default StepBasicIdentity;